

import { BidiModule } from '@angular/cdk/bidi';
import { PortalModule } from '@angular/cdk/portal';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { MwcOutletModule } from 'mwc/core/outlet';
import { MwcI18nModule } from 'mwc/i18n';

import { MwcEmbedEmptyComponent } from './embed-empty.component';
import { MwcEmptyComponent } from './empty.component';
import { MwcEmptyDefaultComponent } from './partial/default';
import { MwcEmptySimpleComponent } from './partial/simple';

@NgModule({
  imports: [BidiModule, CommonModule, PortalModule, MwcOutletModule, MwcI18nModule],
  declarations: [MwcEmptyComponent, MwcEmbedEmptyComponent, MwcEmptyDefaultComponent, MwcEmptySimpleComponent],
  exports: [MwcEmptyComponent, MwcEmbedEmptyComponent]
})
export class MwcEmptyModule {}
